import { Map, fromJS, List } from 'immutable'
import { handleActions } from 'redux-actions'
import ActionHelper from 'helpers/action'
import Psfs from 'lib/psfs/Psfs'
import { LOOKUP_TABLES } from 'constants/appRouting'
import {
  FILTER_TYPE_CREATED_BY,
  FILTER_TYPE_MODIFIED_BY,
} from 'constants/lookupTables'

// constants
export const CLEAR_STORE = 'lookupTables/CLEAR_STORE'
export const SET_TABLES_LIST_PSFS = 'lookupTables/SET_TABLES_LIST_PSFS'
export const SET_SINGLE_TABLE_PSFS = 'lookupTables/SET_SINGLE_TABLE_PSFS'
export const RESET_SINGLE_TABLE_PSFS = 'lookupTables/RESET_SINGLE_TABLE_PSFS'
export const SET_LOOKUP_TABLES_IS_LOADING =
  'lookupTables/SET_LOOKUP_TABLES_IS_LOADING'
export const FETCH_LOOKUP_TABLES_DATA = 'lookupTables/FETCH_LOOKUP_TABLES_DATA'
export const SUCCESS_FETCH_LOOKUP_TABLES_DATA =
  'lookupTables/SUCCESS_FETCH_LOOKUP_TABLES_DATA'
export const FAILURE_FETCH_LOOKUP_TABLES_DATA =
  'lookupTables/FAILURE_FETCH_LOOKUP_TABLES_DATA'
export const CREATE_LOOKUP_TABLE = 'lookupTables/CREATE_LOOKUP_TABLE'
export const DELETE_LOOKUP_TABLE = 'lookupTables/DELETE_LOOKUP_TABLE'
export const UPDATE_LOOKUP_TABLE = 'lookupTables/UPDATE_LOOKUP_TABLE'
export const UPDATE_LOOKUP_TABLE_ROW = 'lookupTables/UPDATE_LOOKUP_TABLE_ROW'
export const LOOKUP_TABLE_ACTION = 'lookupTables/LOOKUP_TABLE_ACTION'
export const FETCH_LOOKUP_TABLES_TABLE_INFO =
  'lookupTables/FETCH_LOOKUP_TABLES_TABLE_INFO'
export const SUCCESS_FETCH_LOOKUP_TABLES_TABLE_INFO =
  'lookupTables/SUCCESS_FETCH_LOOKUP_TABLES_TABLE_INFO'
export const FAILURE_FETCH_LOOKUP_TABLES_TABLE_INFO =
  'lookupTables/FAILURE_FETCH_LOOKUP_TABLES_TABLE_INFO'
export const FETCH_LOOKUP_TABLES_TABLE_DATA =
  'lookupTables/FETCH_LOOKUP_TABLES_TABLE_DATA'
export const SUCCESS_FETCH_LOOKUP_TABLES_TABLE_DATA =
  'lookupTables/SUCCESS_FETCH_LOOKUP_TABLES_TABLE_DATA'
export const FAILURE_FETCH_LOOKUP_TABLES_TABLE_DATA =
  'lookupTables/FAILURE_FETCH_LOOKUP_TABLES_TABLE_DATA'
export const CREATE_LOOKUP_TABLE_DATA_ENTRY =
  'lookupTables/CREATE_LOOKUP_TABLE_DATA_ENTRY'
export const DELETE_LOOKUP_TABLES_TABLE_DATA =
  'lookupTables/DELETE_LOOKUP_TABLES_TABLE_DATA'
export const SET_SELECTED_FILTERS = 'managementUI/SET_SELECTED_FILTERS'
export const FETCH_LOOKUP_TABLES_FILTERS =
  'managementUI/FETCH_LOOKUP_TABLES_FILTERS'
export const SUCCESS_LOOKUP_TABLES_FILTERS =
  'managementUI/SUCCESS_LOOKUP_TABLES_FILTERS'
export const FAILURE_LOOKUP_TABLES_FILTERS =
  'managementUI/FAILURE_LOOKUP_TABLES_FILTERS'

// actions
export const setTablesListPsfs = ActionHelper.createActionObj(
  SET_TABLES_LIST_PSFS,
)
export const setSingleTablePsfs = ActionHelper.createActionObj(
  SET_SINGLE_TABLE_PSFS,
)
export const resetSingleTablePsfs = ActionHelper.createActionObj(
  RESET_SINGLE_TABLE_PSFS,
)
export const clearLookupTablesStore = ActionHelper.createActionObj(CLEAR_STORE)
export const setIsLoading = ActionHelper.createActionObj(
  SET_LOOKUP_TABLES_IS_LOADING,
)
export const fetchLookupTablesData = ActionHelper.createActionObj(
  FETCH_LOOKUP_TABLES_DATA,
)
export const createLookupTable = ActionHelper.createActionObj(
  CREATE_LOOKUP_TABLE,
)
export const deleteLookupTable = ActionHelper.createActionObj(
  DELETE_LOOKUP_TABLE,
)
export const updateLookupTable = ActionHelper.createActionObj(
  UPDATE_LOOKUP_TABLE,
)
export const updateLookupTableRow = ActionHelper.createActionObj(
  UPDATE_LOOKUP_TABLE_ROW,
)
export const lookupTableAction = ActionHelper.createActionObj(
  LOOKUP_TABLE_ACTION,
)
export const fetchLookupTablesTableInfo = ActionHelper.createActionObj(
  FETCH_LOOKUP_TABLES_TABLE_INFO,
)
export const fetchLookupTablesTableData = ActionHelper.createActionObj(
  FETCH_LOOKUP_TABLES_TABLE_DATA,
)
export const resetLookupTablesTableInfo = ActionHelper.createActionObj(
  FAILURE_FETCH_LOOKUP_TABLES_TABLE_INFO,
)
export const resetLookupTablesTableData = ActionHelper.createActionObj(
  FAILURE_FETCH_LOOKUP_TABLES_TABLE_DATA,
)
export const createLookupTableDataEntry = ActionHelper.createActionObj(
  CREATE_LOOKUP_TABLE_DATA_ENTRY,
)
export const deleteLookupTablesTableData = ActionHelper.createActionObj(
  DELETE_LOOKUP_TABLES_TABLE_DATA,
)
export const setSelectedFilters = ActionHelper.createActionObj(
  SET_SELECTED_FILTERS,
)
export const fetchLookupTablesFilters = ActionHelper.createActionObj(
  FETCH_LOOKUP_TABLES_FILTERS,
)

// store
const defaultFiltersList = Map({
  [FILTER_TYPE_CREATED_BY]: [],
  [FILTER_TYPE_MODIFIED_BY]: [],
})

const initialState = () =>
  fromJS({
    tablesListPsfs: new Psfs(LOOKUP_TABLES),
    singleTablePsfs: new Psfs(LOOKUP_TABLES),
    lookupTablesData: Map({
      data: [],
      count: 0,
    }),
    lookupTablesTableInfo: Map({
      columns: [],
      count: null,
      title: '',
      status: '',
    }),
    lookupTablesTableData: Map({
      columns: [],
      data: [],
      count: 0,
    }),
    filtersList: defaultFiltersList,
    selectedFilters: List([]),
    isLoading: true,
  })

const LookupTables = handleActions(
  {
    [CLEAR_STORE]: () => initialState(),
    [SET_TABLES_LIST_PSFS]: (state, action) =>
      state.set('tablesListPsfs', action.payload),
    [SET_SINGLE_TABLE_PSFS]: (state, action) =>
      state.set('singleTablePsfs', action.payload),
    [RESET_SINGLE_TABLE_PSFS]: state =>
      state.set('singleTablePsfs', Map(initialState().get('singleTablePsfs'))),
    [SET_LOOKUP_TABLES_IS_LOADING]: (state, action) =>
      state.set('isLoading', Boolean(action.payload)),
    [SUCCESS_FETCH_LOOKUP_TABLES_DATA]: (state, action) =>
      state.set('lookupTablesData', Map(action.payload)),
    [FAILURE_FETCH_LOOKUP_TABLES_DATA]: state =>
      state.set(
        'lookupTablesData',
        Map(initialState().get('lookupTablesData')),
      ),
    [SUCCESS_FETCH_LOOKUP_TABLES_TABLE_INFO]: (state, action) =>
      state.set('lookupTablesTableInfo', Map(action.payload)),
    [FAILURE_FETCH_LOOKUP_TABLES_TABLE_INFO]: state =>
      state.set(
        'lookupTablesTableInfo',
        Map(initialState().get('lookupTablesTableInfo')),
      ),
    [SUCCESS_FETCH_LOOKUP_TABLES_TABLE_DATA]: (state, action) =>
      state.set('lookupTablesTableData', Map(action.payload)),
    [FAILURE_FETCH_LOOKUP_TABLES_TABLE_DATA]: state =>
      state.set(
        'lookupTablesTableData',
        Map(initialState().get('lookupTablesTableData')),
      ),
    [SET_SELECTED_FILTERS]: (state, action) =>
      state.set('selectedFilters', List(action.payload)),
    [SUCCESS_LOOKUP_TABLES_FILTERS]: (state, action) =>
      state.set('filtersList', Map(action.payload)),
    [FAILURE_LOOKUP_TABLES_FILTERS]: state =>
      state.set('filtersList', defaultFiltersList),
  },
  initialState(),
)

export default LookupTables
